export default function toLower(str) {
    return str.toLocaleLowerCase();
}
;
